import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {MainCampaignActions} from '../../main-campaign.actions';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GlobalService} from '../../../global.service';
import {mainCampaignServices} from '../../main-campaign.services';
import * as _ from 'lodash';

@Component({
    selector: 'app-new-line-step-1',
    templateUrl: './new-line-step-1.component.html',
    styleUrls: ['./new-line-step-1.component.scss']
})
export class NewLineStep1Component implements OnInit {

    step1: any = {};
    option: any;
    broadband: any;
    form: FormGroup;
    subscription: any;
    viewPlan: any;
    isSearching: any = false;

    listPhoneNumber: any = [];

    listPhoneNumber_Receive: any = [];
    idNumberSelect: number;
    numberSelect: number;
    textSearch: number;
    phoneRequest: number;
    initialData: any;

    listPhoneNumberEndReached = true;


    constructor(private store: Store<any>,
                private mainCampaignActions: MainCampaignActions,
                private fb: FormBuilder,
                private mainCampaignServices: mainCampaignServices,
                private globalService: GlobalService) {

        var dataSession = this.globalService.getSession('mainApplication');
        if (dataSession.step1) {
            this.initialData = dataSession.step1;
        }

        /**form */
        this.form = fb.group({
            // textSearch: ["", Validators.compose([Validators.minLength(4) , this.globalService.isNumber]) ],
            phoneNumber: [(this.initialData) ? this.initialData.phoneNumber : ''],
            phoneId: [(this.initialData) ? this.initialData.phoneId : ''],
            phoneId_number: [(this.initialData) ? this.initialData.phoneId_number : ''],
            phoneRequest: [(this.initialData) ? this.initialData.phoneRequest : '', Validators.compose([Validators.minLength(4), this.globalService.isPhone])]
        }, {validator: this.globalService.hasFieldValidStep1('phoneNumber', 'phoneRequest')});

        /**store */
        this.subscription = store.select('mainCampaign').subscribe(store => {
            this.option = store.option;
            this.broadband = store.broadband;
            this.step1 = store.step1;
        });


        /**if have phoneId is set Status Phone Number to 1 */
        if (dataSession.step1) {
            // phone == phoneRequest on Input
            if (dataSession.step1.phone) {
                this.form.get('phoneRequest').setValue(dataSession.step1.phone);
            }

            this.idNumberSelect = dataSession.step1.phoneId;
        }

        if (this.globalService.getSession('NumberPhone')) {
            this.idNumberSelect = this.globalService.getSession('NumberPhone').id;
        }

        this.getListPhone('');

        this.globalService.setSession('NumberPhone', null);
    }

    somethingChangedOnSearchPhone(data) {
        if (!data) {

            let dataRequest = {
                phone: '',
                limit: 15,
                offset: 0,
                campaign_id: this.globalService.getSession('id_campaign'),
                type : this.globalService.getSession('digi_plan_category')
            };

            /**get list phone and search */
            this.mainCampaignServices.getListPhoneNumber(dataRequest).subscribe(res => {
                if (res.success) {
                    this.isSearching = false;
                    this.listPhoneNumber_Receive = res.data.collection;

                    var phoneProcessing = this.globalService.getSession('phoneSelecting');
                    this.listPhoneNumber_Receive.forEach(e => {
                        e.selected = false;
                        if (e.attributes.phone_number === phoneProcessing.attributes.phone_number) {
                            e.selected = true;
                        }
                    });
                }
            });


        }

    }

    ngOnInit() {
        this.viewPlan = this.globalService.getSession('viewPlan');

        this.isSearching = true;
        this.getPhone({
            campaign_id: this.viewPlan.id
        });

    }


    onClickCheckbox(number) {

        this.listPhoneNumber_Receive.forEach(e => {
            e.selected = false;
        });
        number.selected = true;
        this.idNumberSelect = number.id;
        this.numberSelect = number.attributes.phone_number;
        this.form.get('phoneId').setValue(this.idNumberSelect);
        this.form.get('phoneId_number').setValue(this.numberSelect);

        this.globalService.setSession('phoneSelecting', number);

    }

    //new
    onChangeInputSearch() {

        this.isSearching = true;
        let request_number = this.textSearch;
        this.getListPhone(request_number, true);


    }


    getListPhone(request_number, isReset: boolean = false) {
        let dataRequest = {
            phone: request_number,
            limit: 15,
            offset: this.listPhoneNumber_Receive.length,
            campaign_id: this.globalService.getSession('id_campaign'),
            type : this.globalService.getSession('digi_plan_category')
        };


        this.listPhoneNumberEndReached = false;

        if (isReset) {
            this.listPhoneNumber_Receive = [];
            this.listPhoneNumberEndReached = true;

            dataRequest.offset = 0;
        }

        this.mainCampaignServices.getListPhoneNumber(dataRequest).subscribe(res => {
            if (res.success) {
                this.isSearching = false;


                if (res.data.collection.length > 0) {
                    this.listPhoneNumber_Receive = this.listPhoneNumber_Receive.concat(res.data.collection);

                    if (this.listPhoneNumber_Receive.length < 15) {
                        this.listPhoneNumberEndReached = true;
                    }

                    // check when dont have step 1
                    this.listPhoneNumber_Receive.forEach(e => {
                        e.selected = false;
                        if (e.attributes.phone_number === request_number) {
                            e.selected = true;
                            this.idNumberSelect = e.id;
                            this.globalService.setSession('phoneSelecting', e);

                            this.form.get('phoneId').setValue(e.id);
                            this.form.get('phoneId_number').setValue(e.attributes.phone_number);
                        }
                    });


                    // check when have step 1
                    var dataSession = this.globalService.getSession('mainApplication');
                    if (dataSession && dataSession.step1) {
                        this.listPhoneNumber_Receive.forEach(e => {
                            e.selected = false;
                            if (e.id === dataSession.step1.phoneId) {
                                e.selected = true;

                            }
                        });
                    }

                    // console.log(this.listPhoneNumber_Receive)
                    // dont have step 1 and until step 1
                    if (this.globalService.getSession('phoneSelecting')) {
                        let isOutsitelistPhoneNumber: Boolean = true;
                        for (let i = 0; i < this.listPhoneNumber_Receive.length; i++) {
                            if (this.listPhoneNumber_Receive[i].id === this.globalService.getSession('phoneSelecting').id) {
                                this.listPhoneNumber_Receive[i].selected = true;
                                isOutsitelistPhoneNumber = false;
                            }

                        }
                        if (isOutsitelistPhoneNumber) {
                            this.listPhoneNumber_Receive.unshift(this.globalService.getSession('phoneSelecting'));
                        }
                    }
                    // console.log(this.listPhoneNumber_Receive)
                } else {
                    this.listPhoneNumberEndReached = true;
                }
            } else {
                // console.log('Error!');
            }


        });


    }

    getPhone(dataRequest) {

        this.mainCampaignServices.searchPhone(dataRequest).subscribe(res => {

            this.isSearching = false;
            if (res.success) {

                this.listPhoneNumber = res.data.map(res => {
                    return {
                        number: res.phone_number,
                        selected: false
                    };
                });
                return false;
            }

            this.listPhoneNumber = [];

        }, error => {
            this.listPhoneNumber = [];
            this.isSearching = false;
        });
    }


    onClickNext() {
        if (this.form.get('phoneRequest').value) {
            this.step1.phone = this.form.get('phoneRequest').value;
        } else {
            this.step1.phone = this.form.get('phoneNumber').value;
        }

        if (this.step1.phone) {
            this.goToNextPage();
        }


        this.step1.phoneId = this.form.get('phoneId').value;
        this.step1.phoneId_number = this.form.get('phoneId_number').value;

        var phoneSelecting = this.globalService.getSession('phoneSelecting');
        var phoneOnSession = this.globalService.getSession('NumberPhone');


        if (phoneSelecting && !phoneOnSession) {
            /**update status for phoneOnSession */
            var requestUpdateStatusPhoneNumberSelecting = {
                number_id: phoneSelecting.id,
                status: 2
            };
            this.mainCampaignServices.updateStatusPhoneNumber(requestUpdateStatusPhoneNumberSelecting).subscribe(res => {

                if (res.success) {
                    res.data.item.selected = true;
                    this.globalService.setSession('NumberPhone', res.data.item);
                    this.goToNextPage();
                } else {
                    if (confirm(res.error.description)) {
                        let dataRequest = {
                            phone: '',
                            limit: 20,
                            offet: 0,
                            campaign_id: this.globalService.getSession('id_campaign'),
                            type : this.globalService.getSession('digi_plan_category')
                        };
                        this.mainCampaignServices.getListPhoneNumber(dataRequest).subscribe(res => {
                            if (res.success) {
                                this.listPhoneNumber_Receive = res.data.collection;
                            }
                        });
                        this.idNumberSelect = null;
                    }

                }

            });
        }


        if (phoneOnSession && phoneSelecting && phoneOnSession.id != phoneSelecting.id) {

            /**update status for phoneOnSession============================== */
            var requestUpdateStatusPhoneNumberRollback = {
                number_id: phoneOnSession.id,
                status: 2
            };
            this.mainCampaignServices.updateStatusPhoneNumberRollback(requestUpdateStatusPhoneNumberRollback).subscribe(res => {
                // console.log('res on phoneOnSession', res);
            });

            /**update status for phoneSelecting=============================== */
            var requestUpdateStatusPhoneNumberFake = {
                number_id: phoneSelecting.id,
                status: 2
            };
            this.mainCampaignServices.updateStatusPhoneNumber(requestUpdateStatusPhoneNumberFake).subscribe(res => {
                if (res.success) {
                    this.goToNextPage();
                } else {
                //    console.log('2 fail');
                    if (confirm(res.error.description)) {

                        let dataRequest = {
                            phone: '',
                            limit: 20,
                            offet: 0,
                            campaign_id: this.globalService.getSession('id_campaign'),
                            type : this.globalService.getSession('digi_plan_category')
                        };
                        this.mainCampaignServices.getListPhoneNumber(dataRequest).subscribe(res => {
                            if (res.success) {
                                this.listPhoneNumber_Receive = res.data.collection;
                            }
                        });
                        this.idNumberSelect = null;
                    }

                }
            });

            /**set phoneOnSession to Phone Current */
            this.globalService.setSession('NumberPhone', phoneSelecting);

        }

        if (phoneOnSession && phoneSelecting && phoneOnSession.id === phoneSelecting.id) {
            this.goToNextPage();
        }


    }


    goToNextPage() {
        /**save session */
        let newValueSession = {
            option: this.option,
            broad_plan: this.globalService.getSession('broad_plan'),
            step1: Object.assign({}, this.step1)
        };


        newValueSession = Object.assign({}, this.globalService.getSession('mainApplication'), newValueSession);
        this.globalService.setSession('mainApplication', newValueSession);

        // next
        this.store.dispatch(this.mainCampaignActions.updateStep1(this.step1));

    }

    onClickBack() {
        this.store.dispatch(this.mainCampaignActions.stepBack());
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    onScroll() {

        this.getListPhone('');
    }
}
